module.exports = __webpack_public_path__ + "static/media/interview22.6f040318.jpg";